import React from 'react';
import AchCaptureForm from './components/AchCaptureForm';

export const getTokenFromUrl = () => {
  const path = window.location.pathname;
  return path.split('/').pop(); // Gets last segment of URL path
};

function App() {
  const token = getTokenFromUrl();

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <img 
              src="/logo aru.png" 
              alt="ARU Solutions Logo" 
              className="h-12 w-auto"
            />
            <h1 className="text-3xl font-bold text-gray-900">Payment Authorization</h1>
          </div>
        </div>
      </header>
      <main className="flex-grow">
        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <AchCaptureForm token={token} />
        </div>
      </main>
      <footer className="bg-white shadow-inner mt-auto">
        <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8 text-center text-gray-500 text-sm">
          &copy; 2025 ARU
        </div>
      </footer>
    </div>
  );
}

export default App;